import { useContext, useState, useMemo } from "react";
import { useParams } from "react-router-dom";
import Switch from "@mui/material/Switch";

import { Context } from "../../Provider";
import { commonSwal } from "../../../../components/swalAlert/swalAlert";
import { updateFtmAvailability } from "../../service";
import { theme } from "../../../../theme";

const Status = () => {
    const { ftm_id } = useParams();
    const { state, updateRefreshCount } = useContext(Context);
    const { ftm } = state;

    const {
        ftm_is_verify,
        ftm_is_approved_terms_and_conditions,
        ftm_enable_gps_external_device,
        ftm_is_online,
    } = ftm;

    const [isOnline, setIsOnline] = useState(Boolean(ftm_is_online));

    const handleFtmAvailability = (newStatus) => {
        try {
            commonSwal({
                notificationType: newStatus
                    ? "UPDATE_FTM_AVAILABILITY_ONLINE"
                    : "UPDATE_FTM_AVAILABILITY_OFFLINE",
                preConfirm: () => updateFtmAvailability(ftm_id, newStatus),
                isConfirmed: (result) => {
                    if (result.isConfirmed) {
                        updateRefreshCount();
                        setIsOnline(newStatus);
                    } else {
                        setIsOnline((prev) => !prev); // revert if cancelled
                    }
                },
            });
        } catch (error) {
            console.error(error);
            setIsOnline((prev) => !prev);
        }
    };

    const statusList = useMemo(
        () => [
            {
                title: "Terms & Conditions",
                description: `The tradesperson has ${ftm_is_approved_terms_and_conditions === -1 ? "not" : ""} accepted the terms and conditions.`,
                icon: ftm_is_approved_terms_and_conditions === 1 ? "thumb_up" : "thumb_down",
                color: ftm_is_approved_terms_and_conditions === 1 ? "green" : "red",
                show: true,
            },
            {
                title: "Verification",
                description: `Tradesperson is ${ftm_is_verify === 1 ? "verified" : "rejected"}`,
                icon: ftm_is_verify === 1 ? "verified" : "verified_off",
                color: ftm_is_verify === 1 ? "green" : "red",
                show: true,
            },
            {
                title: "GPS Tracker",
                description: `GPS Tracker is ${ftm_enable_gps_external_device === 1 ? "enabled" : "disabled"}`,
                icon: "satellite_alt",
                color: "black",
                show: true,
            },
            {
                title: "Online Status",
                description: `Tradesperson is ${isOnline ? "online" : "offline"}`,
                icon: isOnline ? "notifications" : "notifications_off",
                color: isOnline ? "green" : "red",
                show: true,
                isSwitch: true,
            },
        ],
        [ftm_is_approved_terms_and_conditions, ftm_is_verify, ftm_enable_gps_external_device, isOnline]
    );

    return (
        <div className="row">
            {statusList
                .filter((item) => item.show)
                .map((item, index) => (
                    <div className="col-lg-3 col-sm-6" key={index}>
                        <div className="card h-100">
                            <div className="card-body">
                                <div className="d-flex mb-4">
                                    <i
                                        className="material-icons opacity-10"
                                        style={{ fontSize: 40, color: item.color }}
                                    >
                                        {item.icon}
                                    </i>
                                    {item.isSwitch && (
                                        <div className="form-check form-switch ms-auto is-filled">
                                            <Switch
                                                checked={isOnline}
                                                onChange={(e) => handleFtmAvailability(e.target.checked)}
                                                color={theme.main}
                                                size="small"
                                            />
                                        </div>
                                    )}
                                </div>
                                <p className="mt-1 mb-0 font-weight-bold">{item.title}</p>
                                <span className="text-xs">{item.description}</span>
                            </div>
                        </div>
                    </div>
                ))}
        </div>
    );
};

export default Status;